import { render } from "./ListeFournisseurPage.vue?vue&type=template&id=00c4c127&ts=true"
import script from "./ListeFournisseurPage.vue?vue&type=script&lang=ts"
export * from "./ListeFournisseurPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__